import { inject, Injectable } from '@angular/core'
import { SmartlookService } from './smartlook/smartlook.service'
import { FirebaseAnalyticsService } from './firebase/firebase-analytics.service'
import { UserProfile } from '@core/auth/models/auth.models'
import { AppTrackingTransparencyService } from './app-tracking-transparency/app-tracking-transparency.service'
import { AppTrackingStatus } from 'capacitor-plugin-app-tracking-transparency'

@Injectable({ providedIn: 'root' })
export class AnalyticsHandlerService {
  private readonly _att: AppTrackingTransparencyService = inject(AppTrackingTransparencyService)
  private readonly _smartLook: SmartlookService = inject(SmartlookService)
  private readonly _firebase: FirebaseAnalyticsService = inject(FirebaseAnalyticsService)

  isGranted: boolean
  status: AppTrackingStatus

  async requestPermissions() {
    this.isGranted = await this._att.isGranted()
    this.status = await this._att.getStatus()
  }

  async init(user: UserProfile) {
    this._firebase.registerUser(this.isGranted)
    this._smartLook.init(user, this.status === 'authorized')
  }
}
